(function(global) {
    function Story(data) {
        this.logo = null;
        this.link = null;
        this.bgImage = null;
        this.description = null;
        this.tags = null;
        this.textColor = null;

        $.extend(this, data);
    }

    Story.prototype.html = function() {
        var html = this.template();

        html = html.replace('{{textColor}}', this.textColor);
        html = html.replace('{{link}}', this.link);
        html = html.replace('{{bgImage}}', this.bgImage);
        html = html.replace('{{logo}}', this.logo);
        html = html.replace('{{description}}', this.description);
        html = html.replace('{{tags}}', this.tags);

        return html;
    };

    Story.prototype.template = function() {
        return (
            '' +
            '<div class="wg-cell wg-cell--sm-6 wg-cell--md-4 wg-cell--xl-4">' +
            '<div class="short-story short-story--{{textColor}}">' +
            '<a class="short-story__link" target="_blank" href="{{link}}"></a>' +
            '<span class="shadow"></span>' +
            '<div class="short-story__item">' +
            '<div class="short-story__item__logo">' +
            '<div class="background" style="background-image: url({{bgImage}});"></div>' +
            '<img src="{{logo}}" alt="">' +
            '</div>' +
            '<div class="short-story__item__description h5">' +
            '<span>{{description}}</span>' +
            '</div>' +
            '<div class="short-story__item__tags caps small">' +
            '{{tags}}' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>'
        );
    };

    function CustomerStoriesRandomizer() {
        this.$container = $('#stories');
        this.storiesCollection = [];
        this.countToShow = 3;
        this.storiesData = window.customerStories;

        this.init();
    }

    CustomerStoriesRandomizer.prototype.init = function() {
        if (!this.$container.length) {
            return false;
        }

        if (this.storiesData && this.storiesData.length > this.countToShow) {
            this.shuffleStoriesData();

            if (this.isSuccessStoryPage()) {
                this.filterStoriesData(window.successStoryName);
            }

            this.createStoriesCollection();
            this.render();
        }
    };

    CustomerStoriesRandomizer.prototype.isSuccessStoryPage = function() {
        return Boolean(window.successStoryName);
    };

    CustomerStoriesRandomizer.prototype.createStoriesCollection = function() {
        var stories = this.storiesData.slice(0, this.countToShow);

        stories.forEach(
            function(story) {
                this.storiesCollection.push(new Story(story));
            }.bind(this)
        );
    };

    CustomerStoriesRandomizer.prototype.filterStoriesData = function(successStoryName) {
        this.storiesData = this.storiesData.filter(function(story) {
            return !(story.link.indexOf(successStoryName) >= 0);
        });
    };

    CustomerStoriesRandomizer.prototype.shuffleStoriesData = function() {
        var currentIndex = this.storiesData.length;
        var temporaryValue;
        var randomIndex;

        while (currentIndex !== 0) {
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            temporaryValue = this.storiesData[currentIndex];
            this.storiesData[currentIndex] = this.storiesData[randomIndex];
            this.storiesData[randomIndex] = temporaryValue;
        }
    };

    CustomerStoriesRandomizer.prototype.render = function() {
        var html = '';

        this.storiesCollection.forEach(function(story) {
            html += story.html();
        });

        this.$container.html(html);
    };

    global.CustomerStoriesRandomizer = CustomerStoriesRandomizer;
})(window.wrike);



// WEBPACK FOOTER //
// ./assets/js/common/widgets/customer-stories-randomizer.js